<template>
  <!-- 移动端首页 -->
  <div class="home-index h5content">
    <!-- 功能列表 -->
    <div class="function-list">
      <div
        class="function-item"
        v-for="(item, index) in functionList"
        :key="index"
        @click="goToPage(item)"
      >
        <img class="function-icon" :src="item.imageUrl" />
        <div class="function-label">{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import reportImage from "@/assets/img/inpage/report.png";
import todoImage from "@/assets/img/inpage/todo.png";

import { userStore } from "@/store/user.js";

export default {
  name: "HomeIndex",
  data() {
    return {
      functionList: [
        {
          label: "报告检查",
          key: "reportCheck",
          imageUrl: reportImage,
          name: "reportCheckMobileSelectClinic",
        },
        {
          label: "待办",
          key: "todo",
          imageUrl: todoImage,
          name: "waitingProcessing",
        },
      ],
    };
  },
  mounted() {
    //页面标题
    document.title = "SCRM";

    const user = userStore();
    //开始刷新Token的监听
    user.refreshTokenTime();
  },
  methods: {
    //跳转
    goToPage(item) {
      if (item.name) {
        this.$router.push({
          name: item.name,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home-index {
  min-height: 100vh;
  background-color: #f7f7f7;
  padding: 0.25rem;

  .function-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.25rem;

    .function-item {
      display: flex;
      justify-content: start;
      align-items: center;
      background-color: #fff;
      border-radius: 0.167rem;
      padding: 0.333rem 0.25rem;
      box-shadow: 0 0.042rem 0.167rem rgba(0, 0, 0, 0.05);
      transition: all 0.3s;

      &:active {
        transform: scale(0.95);
        background-color: #f8f8f8;
      }

      .function-icon {
        width: 0.333rem;
        height: 0.333rem;
        background-color: #fff;
        margin-right: 0.25rem;
        position: relative;
        top: 0.021rem;
      }

      .function-label {
        font-size: 0.292rem;
        color: #333;
      }
    }
  }
}
</style>
